import _ from "lodash";

import * as addAutomation from '@/api/crm/automations/addAutomation';
import * as updateAutomation from '@/api/crm/automations/updateAutomation';
import * as deleteAutomation from '@/api/crm/automations/deleteAutomation';
import * as getAutomations from '@/api/crm/automations/getAutomations.js';

import * as addAutomationAction from '@/api/crm/automations/addAutomationAction';
import * as updateAutomationAction from '@/api/crm/automations/updateAutomationAction';
import * as deleteAutomationAction from '@/api/crm/automations/deleteAutomationAction';


export default {
    namespaced: true,
    state: {
        automations: [],
        triggerTypes: [
            "Booking created",
            "Booking confirmed",
            "Booking no show",
            "Booking arrived",
            "Booking rejected",
            "30 days before guest birthday",
            "Guest birthday",
            "Dynamic form submitted",
            "Guest created"
        ],
        //conditionTypes: ["Always", "HasReadMailCondition"],
        conditionTypes: [
            { type: "HasReadMailCondition", description: "Has read mail" },
            { type: "HasClickedMailCondition", description: "Has clicked mail" },
            { type: "HasLabelCondition", description: "User has label" },
            { type: "HasConsentCondition", description: "User has consent" }
        ],
        //actionTypes: ["SendMailAction", "SendSmsAction"],
        actionTypes: [
            { type: "SendMailAction", description: "Send a mail" },
            { type: "SendSmsAction", description: "Send a SMS" },
            { type: "AddPointsAction", description: "Add value points" },
            { type: "AddLabelAction", description: "Add label to user" },
            //{ type: "CreateNightpayVoucherAction", description: "Create Nightpay voucher " }
        ],
        actionStyling: {
            "SendMailAction": { icon: "MailIcon", color: "primary", description: "Send mail " },
            "SendSmsAction": { icon: "MessageCircleIcon", color: "primary", description: "Send SMS " },
            "AddPointsAction": { icon: "TrendingUpIcon", color: "primary", description: "Add value points " },
            "AddLabelAction": { icon: "TagIcon", color: "primary", description: "Add label to user " },
            //"CreateNightpayVoucherAction": { icon: "DollarSignIcon", color: "primary", description: "Create Nightpay voucher " },
        },

    },
    mutations: {
        gotAutomations(state, result) {
            state.automations = result;
        },
    },
    actions: {
        async getAll({ commit, getters }, force = true) {
            if (!force && getters.automations.length > 0) return;
            const result = await getAutomations.get();
            if (result) commit("gotAutomations", result);
        },
        async create({ dispatch }, dto) {
            await addAutomation.post(dto);
            await dispatch("getAll")
        },
        async update({ dispatch }, dto) {
            await updateAutomation.put(dto);
            await dispatch("getAll")
        },
        async delete({ dispatch }, id) {
            await deleteAutomation.del(id);
            await dispatch("getAll")
        },
        async createAction({ dispatch }, dto) {
            await addAutomationAction.post(dto);
            await dispatch("getAll")
        },
        async updateAction({ dispatch }, dto) {
            await updateAutomationAction.put(dto);
            await dispatch("getAll")
        },
        async deleteAction({ dispatch }, { automationId, actionId }) {
            await deleteAutomationAction.del(automationId, actionId);
            await dispatch("getAll")
        },
    },
    getters: {
        automation: state => (id) => state.automations.find(e => e.id === id),
        automations: state => state.automations,
        action: state => (automationId, actionId) => state.automations.find(e => e.id === automationId).actions.find(e => e.id === actionId),
        triggerTypes: state => state.triggerTypes,
        actionStyling: state => state.actionStyling,
        actionTypes: state => state.actionTypes,
        conditionTypes: state => state.conditionTypes,
    }
};
